import { LineupPlayer } from '@collector/desktop-feature-lineups'
import { StatId } from '@collector/sportsapi-client-legacy'
import { IncidentPlayerOption } from '@desktop/views/Relation/types'

export function createIncidentPlayerOption(
  subParticipant: LineupPlayer,
): IncidentPlayerOption {
  return {
    name: `${subParticipant.shirt_nr ?? ''} ${subParticipant.short_name}`.trim(),
    value: {
      shortName: subParticipant.short_name,
      id: subParticipant.id,
      teamId: subParticipant.team_id,
      lineupId: subParticipant.lineup_id ?? null,
    },
    metadata: {
      position: subParticipant.position,
      hasSecondaryPosition: !!subParticipant.has_secondary_position,
      shirtNr: subParticipant.shirt_nr ?? '',
      stats: (subParticipant.stats ?? []).reduce(
        (acc, stat) => {
          acc[stat.id] = stat.value
          return acc
        },
        {} as Record<StatId, unknown>,
      ),
      pitcherOrder: subParticipant.pitcher_order,
    },
  }
}
